import { useCallback } from 'react';
import useTextLocalizer from '../../locale/useTextLocalizer';
export const useIconA11yInfo = () => {
  const iconLocalizerKey = 'SASDesign-Icon-gui-icu';
  const localize = useTextLocalizer(iconLocalizerKey);
  return useCallback(props => {
    const {
      tooltip,
      icon,
      testId
    } = props;
    let {
      ariaLabel,
      ariaHidden
    } = props;
    const tooltipKey = icon?.tooltipKey;
    let localizedTooltip = tooltipKey ? localize(tooltipKey) : undefined;

    // Only use the default tooltip if its key returns anything other than itself, which happens when nothing is found,
    // or "__0__", which is a special key to supress the included tooltip
    if (
    // When running Jest tests localizedTooltip always gets set to the tooltip key
    // Don't supress showing the key in that case so we have something to check for in our tests
    localizedTooltip === `${iconLocalizerKey}.${tooltipKey}` && !testId || localizedTooltip === '__0__') {
      if (localizedTooltip === '__0__' && !ariaLabel) {
        // If no aria label was passed in for this case set ariaLabel to empty string so that it can pick up aria-hidden below
        ariaLabel = '';
      }
      localizedTooltip = '';
    }

    // Only check for undefined here to allow the user to pass in an empty string to clear the tooltip
    const tooltipA11Y = tooltip === undefined ? localizedTooltip : tooltip;
    // When blank string aria and tooltip are passed, or key is '__0__' and no custom aria label or tooltip are set, allow no aria-label and set aria-hidden=true
    if (ariaLabel === '' && tooltipA11Y === '') {
      ariaHidden = true;
    } else {
      // Otherwise if no aria label was passed in, use either the tooltip if one is set, or the icon default tooltip
      ariaLabel = ariaLabel || tooltip || localizedTooltip;
    }
    return {
      ariaLabel: !!ariaLabel ? ariaLabel : undefined,
      ariaHidden,
      tooltip: !!tooltipA11Y ? tooltipA11Y : undefined
    };
  }, [localize]);
};
//# sourceMappingURL=useIconA11yInfo.js.map